export const cloudinaryImage = (path: string) =>
  `https://res.cloudinary.com/dha23twl5/image/upload/${path}`;
